<div class="play_icon-container">
  <div class="play_icon-circle" [style.background]="color">
    <div class="play_icon-arrow" [style.border-left-color]="arrowColor">
    </div>
  </div>
</div>
